import { render, staticRenderFns } from "./SupplierModulesTab.vue?vue&type=template&id=ac13dd54&scoped=true"
import script from "./SupplierModulesTab.vue?vue&type=script&lang=ts"
export * from "./SupplierModulesTab.vue?vue&type=script&lang=ts"
import style0 from "./SupplierModulesTab.vue?vue&type=style&index=0&id=ac13dd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac13dd54",
  null
  
)

export default component.exports